module.exports = __webpack_public_path__ + "img/instructions.4e967237.png";